import * as React from 'react'
import { User } from 'shared/types'
import { UserAvatar } from 'shared/atoms/UserAvatar'
import { useRecordContext } from 'react-admin'

interface UserBlockProps {
  label: string
  showRoles?: boolean
}

export const UserBlock: React.FC<UserBlockProps> = ({ showRoles }) => {
  const record = useRecordContext()
  if (!record) return null

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ marginRight: 10 }}>
        <UserAvatar
          // src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
          src={null /* TODO: load this in when we support user avatars */}
          name={record.name || record.email}
          size={48}
          style={{ border: 'none' }}
        />
      </div>

      <div>
        <div>
          <strong>{record.name}</strong>
          {showRoles &&
            record.roles.map(function (role, idx) {
              return (
                <small
                  style={{
                    color: 'white',
                    background: 'orange',
                    textTransform: 'uppercase',
                    padding: '1px 3px',
                    margin: '0px 4px',
                  }}
                  key={idx}
                >
                  {role}
                </small>
              )
            })}
        </div>
        <div>{record.email}</div>
      </div>
    </div>
  )
}
